function checkLimitedUser(res) {

  if(res.data.resultCode == 1400) {
    return location.href = '/limitedUser'
  } else if(res.data.resultCode == 1310){
    return location.href = '/login'
  }
  else {
    return res
  }
}

export { checkLimitedUser }